import {
  OWNERS_CTA_DURATION,
  OWNERS_CTA_EASE,
  OWNERS_CTA_Y,
} from "./owners-cta-gsap.js";

/** Right column starts slightly after the main block (same idea as `image-text`). */
const IMAGES_START = 0.12;

/**
 * Scroll-in for `.follow-cta`: one motion for `.follow-cta__content`, one for `.follow-cta__images`.
 *
 * @param {gsap.core.Timeline} timeline
 * @param {HTMLElement} section — `.follow-cta`
 * @param {number} [position=0] — timeline label
 * @returns {boolean}
 */
export function appendFollowCtaReveal(timeline, section, position = 0) {
  const content = section.querySelector(".follow-cta__content");
  const images = section.querySelector(".follow-cta__images");

  if (!content) {
    return false;
  }

  timeline.fromTo(
    content,
    { autoAlpha: 0, y: OWNERS_CTA_Y },
    {
      autoAlpha: 1,
      y: 0,
      duration: OWNERS_CTA_DURATION,
      ease: OWNERS_CTA_EASE,
      force3D: true,
    },
    position,
  );

  if (images) {
    timeline.fromTo(
      images,
      { autoAlpha: 0, y: OWNERS_CTA_Y },
      {
        autoAlpha: 1,
        y: 0,
        duration: OWNERS_CTA_DURATION,
        ease: OWNERS_CTA_EASE,
        force3D: true,
      },
      position + IMAGES_START,
    );
  }

  return true;
}
